  <template>
    <div class="profitability" ref="slideContainer">
      <Title :zhTitle="'盈利能力'" :enTitle="'Profitability'"></Title>
      <div v-if="types == 1" class="cards1">
        <div class="card" v-if="array[0] === 1">
          <div v-if="language === 'zh'" class="zh">
            <div class="card-title">{{ jsonData.year }}{{ periodName }}</div>
            <div class="card-text">销售费用率</div>
            <div class="num">
              {{ xsfyl }}<span class="unit">{{ xsfylUnit }}</span>
            </div>
          </div>
          <div v-else-if="language === 'en'" class="en">
            <div class="card-title">{{ jsonData.year }}{{ periodNameEng }}</div>
            <div class="card-text">Selling Expense Ratio</div>
            <div :class="xsfyl ==='Undisclosed' ? 'num1':'num'">
              {{ xsfyl }}<span class="unit">{{ xsfylUnit }}</span>
            </div>
          </div>
          <div class="charts" ref="chart1"></div>
        </div>
        <div class="card" v-if="array[1] === 1">
          <div v-if="language === 'zh'" class="zh">
            <div class="card-title">{{ jsonData.year }}{{ periodName }}</div>
            <div class="card-text">管理费用率</div>
            <div class="num">
              {{ glfyl }}<span class="unit">{{ glfylUnit }}</span>
            </div>
          </div>
          <div v-else-if="language === 'en'" class="en">
            <div class="card-title">{{ jsonData.year }}{{ periodNameEng }}</div>
            <div class="card-text">Administrative Expense Ratio</div>
            <div :class="glfyl ==='Undisclosed' ? 'num1':'num'">
              {{ glfyl }}<span class="unit">{{ glfylUnit }}</span>
            </div>
          </div>
          <div class="charts" ref="chart2"></div>
        </div>
        <div class="card" v-if="array[2] === 1">
          <div v-if="language === 'zh'" class="zh">
            <div class="card-title">{{ jsonData.year }}{{ periodName }}</div>
            <div class="card-text">财务费用率</div>
            <div class="num">
              {{ cwfyl }}<span class="unit">{{ cwfylUnit }}</span>
            </div>
          </div>
          <div v-else-if="language === 'en'" class="en">
            <div class="card-title">{{ jsonData.year }}{{ periodNameEng }}</div>
            <div class="card-text">Financial Expense Ratio</div>
            <div :class="cwfyl ==='Undisclosed' ? 'num1':'num'">
              {{ cwfyl }}<span class="unit">{{ cwfylUnit }}</span>
            </div>
          </div>
          <div class="charts" ref="chart3"></div>
        </div>
        <div class="card" v-if="array[3] === 1">
          <div v-if="language === 'zh'" class="zh">
            <div class="card-title">{{ jsonData.year }}{{ periodName }}</div>
            <div class="card-text">研发费用率</div>
            <div class="num">
              {{ yffyl }}<span class="unit">{{ yffylUnit }}</span>
            </div>
          </div>
          <div v-else-if="language === 'en'" class="en">
            <div class="card-title">{{ jsonData.year }}{{ periodNameEng }}</div>
            <div class="card-text">R&D Rate</div>
            <div :class="yffyl ==='Undisclosed' ? 'num1':'num'">
              {{ yffyl }}<span class="unit">{{ yffylUnit }}</span>
            </div>
          </div>
          <div class="charts" ref="chart4"></div>
        </div>
      </div>
      <div v-if="types == 2" class="cards">
        <div class="card2" v-if="array[0] === 1">
          <div v-if="language === 'zh'" class="zh">
            <div class="card-title">{{ jsonData.year }}{{ periodName }}</div>
            <div class="card-text">销售费用率</div>
            <div class="num">
              {{ xsfyl }}<span class="unit">{{ xsfylUnit }}</span>
            </div>
          </div>
          <div v-else-if="language === 'en'" class="en">
            <div class="card-title">{{ jsonData.year }}{{ periodNameEng }}</div>
            <div class="card-text">Selling Expense Ratio</div>
            <div :class="xsfyl ==='Undisclosed' ? 'num1':'num'">
              {{ xsfyl }}<span class="unit">{{ xsfylUnit }}</span>
            </div>
          </div>
          <div class="charts2" ref="chart1"></div>
        </div>
        <div class="card2" v-if="array[1] === 1">
          <div v-if="language === 'zh'" class="zh">
            <div class="card-title">{{ jsonData.year }}{{ periodName }}</div>
            <div class="card-text">管理费用率</div>
            <div class="num">
              {{ glfyl }}<span class="unit">{{ glfylUnit }}</span>
            </div>
          </div>
          <div v-else-if="language === 'en'" class="en">
            <div class="card-title">{{ jsonData.year }}{{ periodNameEng }}</div>
            <div class="card-text">Administrative Expense Ratio</div>
            <div :class="glfyl ==='Undisclosed' ? 'num1':'num'">
              {{ glfyl }}<span class="unit">{{ glfylUnit }}</span>
            </div>
          </div>
          <div class="charts2" ref="chart2"></div>
        </div>
        <div class="card2" v-if="array[2] === 1">
          <div v-if="language === 'zh'" class="zh">
            <div class="card-title">{{ jsonData.year }}{{ periodName }}</div>
            <div class="card-text">财务费用率</div>
            <div class="num">
              {{ cwfyl }}<span class="unit">{{ cwfylUnit }}</span>
            </div>
          </div>
          <div v-else-if="language === 'en'" class="en">
            <div class="card-title">{{ jsonData.year }}{{ periodNameEng }}</div>
            <div class="card-text">Financial Expense Ratio</div>
            <div :class="cwfyl ==='Undisclosed' ? 'num1':'num'">
              {{ cwfyl }}<span class="unit">{{ cwfylUnit }}</span>
            </div>
          </div>
          <div class="charts2" ref="chart3"></div>
        </div>
        <div class="card2" v-if="array[3] === 1">
          <div v-if="language === 'zh'" class="zh">
            <div class="card-title">{{ jsonData.year }}{{ periodName }}</div>
            <div class="card-text">研发费用率</div>
            <div class="num">
              {{ yffyl }}<span class="unit">{{ yffylUnit }}</span>
            </div>
          </div>
          <div v-else-if="language === 'en'" class="en">
            <div class="card-title">{{ jsonData.year }}{{ periodNameEng }}</div>
            <div class="card-text">R&D Rate</div>
            <div :class="yffyl ==='Undisclosed' ? 'num1':'num'">
              {{ yffyl }}<span class="unit">{{ yffylUnit }}</span>
            </div>
          </div>
          <div class="charts2" ref="chart4"></div>
        </div>
      </div>
      <div v-if="types == 3" class="cards">
        <div class="card3" v-if="array[0] === 1">
          <div v-if="language === 'zh'" class="zh">
            <div class="card-title">{{ jsonData.year }}{{ periodName }}</div>
            <div class="card-text">销售费用率</div>
            <div class="num">
              {{ xsfyl }}<span class="unit">{{ xsfylUnit }}</span>
            </div>
          </div>
          <div v-else-if="language === 'en'" class="en">
            <div class="card-title">{{ jsonData.year }}{{ periodNameEng }}</div>
            <div class="card-text">Selling Expense Ratio</div>
            <div :class="xsfyl ==='Undisclosed' ? 'num1':'num'">
              {{ xsfyl }}<span class="unit">{{ xsfylUnit }}</span>
            </div>
          </div>
          <div class="charts3" ref="chart1"></div>
        </div>
        <div class="card3" v-if="array[1] === 1">
          <div v-if="language === 'zh'" class="zh">
            <div class="card-title">{{ jsonData.year }}{{ periodName }}</div>
            <div class="card-text">管理费用率</div>
            <div class="num">
              {{ glfyl }}<span class="unit">{{ glfylUnit }}</span>
            </div>
          </div>
          <div v-else-if="language === 'en'" class="en">
            <div class="card-title">{{ jsonData.year }}{{ periodNameEng }}</div>
            <div class="card-text">Administrative Expense Ratio</div>
            <div :class="glfyl ==='Undisclosed' ? 'num1':'num'">
              {{ glfyl }}<span class="unit">{{ glfylUnit }}</span>
            </div>
          </div>
          <div class="charts3" ref="chart2"></div>
        </div>
        <div class="card3" v-if="array[2] === 1">
          <div v-if="language === 'zh'" class="zh">
            <div class="card-title">{{ jsonData.year }}{{ periodName }}</div>
            <div class="card-text">财务费用率</div>
            <div class="num">
              {{ cwfyl }}<span class="unit">{{ cwfylUnit }}</span>
            </div>
          </div>
          <div v-else-if="language === 'en'" class="en">
            <div class="card-title">{{ jsonData.year }}{{ periodNameEng }}</div>
            <div class="card-text">Financial Expense Ratio</div>
            <div :class="cwfyl ==='Undisclosed' ? 'num1':'num'">
              {{ cwfyl }}<span class="unit">{{ cwfylUnit }}</span>
            </div>
          </div>
          <div class="charts3" ref="chart3"></div>
        </div>
        <div class="card3" v-if="array[3] === 1">
          <div v-if="language === 'zh'" class="zh">
            <div class="card-title">{{ jsonData.year }}{{ periodName }}</div>
            <div class="card-text">研发费用率</div>
            <div class="num">
              {{ yffyl }}<span class="unit">{{ yffylUnit }}</span>
            </div>
          </div>
          <div v-else-if="language === 'en'" class="en">
            <div class="card-title">{{ jsonData.year }}{{ periodNameEng }}</div>
            <div class="card-text">R&D Rate</div>
            <div :class="yffyl ==='Undisclosed' ? 'num1':'num'">
              {{ yffyl }}<span class="unit">{{ yffylUnit }}</span>
            </div>
          </div>
          <div class="charts3" ref="chart4"></div>
        </div>
      </div>
      <div v-if="types == 4" class="cards4">
        <div class="column">
          <div class="card4">
            <div v-if="language === 'zh'" class="zh" style="width: 149px">
              <div class="card-title">{{ jsonData.year }}{{ periodName }}</div>
              <div class="card-text">销售费用率</div>
              <div class="num">
                {{ xsfyl }}<span class="unit">{{ xsfylUnit }}</span>
              </div>
            </div>
            <div v-else-if="language === 'en'" class="en" style="width: 149px">
              <div class="card-title">{{ jsonData.year }}{{ periodNameEng }}</div>
              <div class="card-text">Selling Expense Ratio</div>
              <div :class="xsfyl ==='Undisclosed' ? 'num1':'num'">
                {{ xsfyl }}<span class="unit">{{ xsfylUnit }}</span>
              </div>
            </div>
            <div class="line"></div>
            <div class="charts4" ref="chart1"></div>
          </div>
          <div class="card4">
            <div v-if="language === 'zh'" class="zh" style="width: 149px">
              <div class="card-title">{{ jsonData.year }}{{ periodName }}</div>
              <div class="card-text">管理费用率</div>
              <div class="num">
                {{ glfyl }}<span class="unit">{{ glfylUnit }}</span>
              </div>
            </div>
            <div v-else-if="language === 'en'" class="en" style="width: 149px">
              <div class="card-title">{{ jsonData.year }}{{ periodNameEng }}</div>
              <div class="card-text">Administrative Expense Ratio</div>
              <div :class="glfyl ==='Undisclosed' ? 'num1':'num'">
                {{ glfyl }}<span class="unit">{{ glfylUnit }}</span>
              </div>
            </div>
            <div class="line"></div>
            <div class="charts4" ref="chart2"></div>
          </div>
        </div>
        <div class="column mt">
          <div class="card4">
            <div v-if="language === 'zh'" class="zh" style="width: 149px">
              <div class="card-title">{{ jsonData.year }}{{ periodName }}</div>
              <div class="card-text">财务费用率</div>
              <div class="num">
                {{ cwfyl }}<span class="unit">{{ cwfylUnit }}</span>
              </div>
            </div>
            <div v-else-if="language === 'en'" class="en" style="width: 149px">
              <div class="card-title">{{ jsonData.year }}{{ periodNameEng }}</div>
              <div class="card-text">Financial Expense Ratio</div>
              <div :class="cwfyl ==='Undisclosed' ? 'num1':'num'">
                {{ cwfyl }}<span class="unit">{{ cwfylUnit }}</span>
              </div>
            </div>
            <div class="line"></div>
            <div class="charts4" ref="chart3"></div>
          </div>
          <div class="card4">
            <div v-if="language === 'zh'" class="zh" style="width: 149px">
              <div class="card-title">{{ jsonData.year }}{{ periodName }}</div>
              <div class="card-text">研发费用率</div>
              <div class="num">
                {{ yffyl }}<span class="unit">{{ yffylUnit }}</span>
              </div>
            </div>
            <div v-else-if="language === 'en'" class="en" style="width: 149px">
              <div class="card-title">{{ jsonData.year }}{{ periodNameEng }}</div>
              <div class="card-text">R&D Rate</div>
              <div :class="yffyl ==='Undisclosed' ? 'num1':'num'">
                {{ yffyl }}<span class="unit">{{ yffylUnit }}</span>
              </div>
            </div>
            <div class="line"></div>
            <div class="charts4" ref="chart4"></div>
          </div>
        </div>
      </div>
    </div>
  </template>

  <script>
  import Title from '@/components/title.vue'
  import { mapState } from 'vuex'
  import * as echarts from 'echarts'

  export default {
    name: 'profitability2',
    components: {
      Title,
    },
    props: {
      index: {
        type: Number,
      },
    },
    data() {
      return {
        types: 0,
        array: [],
        observer: null, // IntersectionObserver 对象
        barOption: {
          xAxis: [
            {
              type: 'value',
              min: 0,
              max: 100,
              show: false,
              axisLabel: {
                color: '#696969',
              },
            }
          ],
          yAxis: [
            {
              type: 'category',
              axisLine: {
                show: false,
                lineStyle: {
                  color: '#F0F0F0',
                },
              },
              axisTick: {
                show: false,
              },
              axisLabel: {
                color: '#696969',
              },
              data: [],
            },
          ],
          grid: {
            top: 20,
            left: '2%',
            right: '4%',
            bottom: -20,
            containLabel: true,
          },
          series: [
            {
              type: 'pictorialBar', //pictorialBar(象形柱图)
              symbolSize: [6, 11], //椭圆的大小[宽，高]
              symbolOffset: [1, 0], //图形偏移[x轴，y轴]，不确定的话，可以微调，本实例x轴叠加了柱状之间的间距[-7+(间距7/2),y轴]
              z: 12, //图形的层级，控制图形的前后顺序，z值小的图形会被z值大的图形覆盖
              symbolPosition: 'end', //椭圆位置，默认'start'，在最底下，end是最上面
              itemStyle: {
                color: '#F06160',
              },
              data: [],
            },
            {
              type: 'bar',
              barWidth: 11,
              showBackground: true,
              backgroundStyle: {
                color: 'rgba(211, 47, 46, 0.12)',
                borderRadius: 6,
              },
              label: {
                show: true,
                position: 'right',
                offset: [-53, -15],
                color: '#F78A16',
                fontSize: 14,
                fontWeight: 600,
                formatter: '{c}%',
              },
              itemStyle: {
                borderRadius: 6,
                // 图形样式
                color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                  {
                    offset: 0, // 0%处的颜色
                    color: '#FEAB66',
                  },
                  {
                    offset: 1, // 100%处的颜色
                    color: '#d32f2e',
                  },
                ]),
              },
              data: [],
            },
            // 第一个圆柱底部的椭圆形
            {
              type: 'pictorialBar',
              symbolSize: [6, 11],
              symbolOffset: [-1, 0],
              z: 12,
              itemStyle: {
                color: '#F06160',
              },
              data: [],
            },
          ],
        },
        bar1Data: {
          yAxisData: [],
          seriesData: [],
        },
        bar2Data: {
          yAxisData: [],
          seriesData: [],
        },
        bar3Data: {
          yAxisData: [],
          seriesData: [],
        },
        bar4Data: {
          yAxisData: [],
          seriesData: [],
        },
        pageData: {},
        xsfyl: '', // 销售费用率
        xsfylUnit: '', // 销售费用率单位
        glfyl: '', // 管理费用率
        glfylUnit: '', // 管理费用率单位
        cwfyl: '', // 财务费用率
        cwfylUnit: '', // 财务费用率单位
        yffyl: '', // 研发费用率
        yffylUnit: '', // 研发费用率单位
      }
    },
    computed: {
      ...mapState(['theme', 'language', 'jsonData', 'periodName', 'periodNameEng','isLongChart']),
    },
    watch:{
      language(newVal, oldVal) { // 监听语言变化
        this.initData(); // 重新初始化数据
      }
    },
    mounted() {
      this.initData(); // 初始化数据
    },
    beforeDestroy() { // 销毁组件时，销毁echarts实例
      const myChart1 = echarts.init(this.$refs.chart1)
      const myChart2 = echarts.init(this.$refs.chart2)
      const myChart3 = echarts.init(this.$refs.chart3)
      const myChart4 = echarts.init(this.$refs.chart4)
      if (this.observer) {
        this.observer.disconnect()
      }
      if (myChart1) {
        myChart1.dispose()
      }
      if (myChart2) {
        myChart2.dispose()
      }
      if (myChart3) {
        myChart3.dispose()
      }
      if (myChart4) {
        myChart4.dispose()
      }
    },
    methods: {
      initData() {
        this.types = 0; // 初始化显示图形
        this.initObserver() // 初始化IntersectionObserver

        let data = JSON.parse(this.jsonData.moduleData)
        if (this.language == 'zh') { // 根据语言获取相应数据
          data = JSON.parse(this.jsonData.moduleData)
        } else {
          data = JSON.parse(this.jsonData.moduleDataEng)
        }
        this.pageData = data[this.index] // 获取当前页面数据
        this.type = data[this.index].graphId == 5 ? '3d' : data[this.index].graphId == 1 ? 'bar' : 'area' // 获取图形类型
        this.array = [0, 0, 0, 0] // 初始化数组
        if (this.pageData.xsfylData.length > 0) { // 销售费用率数据
          if (this.pageData.xsfylData[0].period.match(/\d+/) != this.jsonData.year) { // 判断是否为最新年份数据
            this.xsfyl = this.language === 'zh' ? '未披露' : 'Undisclosed';
          } else {
            this.xsfyl = this.pageData.xsfylData[0].realityValue
            this.xsfylUnit = this.pageData.xsfylData[0].unit
          }
          this.bar1Data.yAxisData = []; // 清空数组
          this.bar1Data.seriesData = []; // 清空数组
          this.pageData.xsfylData.forEach(item => {
            this.bar1Data.yAxisData.push(item.period) // 获取x轴数据
            this.bar1Data.seriesData.push({value: item.value, label: item.realityValue}) // 获取y轴数据
          })
          this.array[0] = 1 // 显示销售费用率图形
          this.types = this.types + 1 // 显示销售费用率图形
        }
        if (this.pageData.glfylData.length > 0) { // 管理费用率数据
          if (this.pageData.glfylData[0].period.match(/\d+/) != this.jsonData.year) { // 判断是否为最新年份数据
            this.glfyl = this.language === 'zh' ? '未披露' : 'Undisclosed';
          } else {
            this.glfyl = this.pageData.glfylData[0].realityValue;
            this.glfylUnit = this.pageData.glfylData[0].unit
          }
          this.bar2Data.yAxisData = []; // 清空数组
          this.bar2Data.seriesData = []; // 清空数组
          this.pageData.glfylData.forEach(item => {
            this.bar2Data.yAxisData.push(item.period) // 获取x轴数据
            this.bar2Data.seriesData.push({value: item.value, label: item.realityValue}) // 获取y轴数据
          })
          this.array[1] = 1 // 显示管理费用率图形
          this.types = this.types + 1 // 显示管理费用率图形
        }
        if (this.pageData.cwfylData.length > 0) { // 财务费用率数据
          if (this.pageData.cwfylData[0].period.match(/\d+/) != this.jsonData.year) { // 判断是否为最新年份数据
            this.cwfyl = this.language === 'zh' ? '未披露' : 'Undisclosed';
          } else {
            this.cwfyl = this.pageData.cwfylData[0].realityValue
            this.cwfylUnit = this.pageData.cwfylData[0].unit
          }
          this.bar3Data.yAxisData = []; // 清空数组
          this.bar3Data.seriesData = []; // 清空数组
          this.pageData.cwfylData.forEach(item => {
            this.bar3Data.yAxisData.push(item.period) // 获取x轴数据
            this.bar3Data.seriesData.push({value: item.value, label: item.realityValue}) // 获取y轴数据
          })
          this.array[2] = 1 // 显示财务费用率图形
          this.types = this.types + 1 // 显示财务费用率图形
        }
        if (this.pageData.yffylData.length > 0) { // 研发费用率数据
          if (this.pageData.yffylData[0].period.match(/\d+/) != this.jsonData.year) { // 判断是否为最新年份数据
            this.yffyl = this.language === 'zh' ? '未披露' : 'Undisclosed';
          } else {
            this.yffyl = this.pageData.yffylData[0].realityValue
            this.yffylUnit = this.pageData.yffylData[0].unit
          }
          this.bar4Data.yAxisData = []; // 清空数组
          this.bar4Data.seriesData = []; // 清空数组
          this.pageData.yffylData.forEach(item => {
            this.bar4Data.yAxisData.push(item.period) // 获取x轴数据
            this.bar4Data.seriesData.push({value: item.value, label: item.realityValue}) // 获取y轴数据
          })
          this.array[3] = 1 // 显示研发费用率图形
          this.types = this.types + 1 // 显示研发费用率图形
        }
      },
      initObserver() {
        if (this.isLongChart) { // 如果是长图，则直接初始化echarts
          setTimeout(() => {
            this.initChart();
          }, 200)
        } else {
          // 创建一个新的 IntersectionObserver 对象，当其监听到目标元素的可见部分（的比例）超过了一个或多个阈值（threshold）时，会执行指定的回调函数
          this.observer = new IntersectionObserver(
              entries => {
                entries.forEach(entry => {
                  if (entry.isIntersecting) {
                    this.initChart()
                    this.observer.disconnect() // 一旦元素进入视窗，就断开观察器
                  }
                })
              },
              {
                threshold: 0.1, // 当目标元素的可见比例达到0%时，触发回调
              }
          )
          this.observer.observe(this.$refs.slideContainer)
        }
      },
      initChart() {
        if (this.$refs.chart1) { // 初始化echarts
          const myChart1 = echarts.init(this.$refs.chart1)
          const option1 = JSON.parse(JSON.stringify(this.barOption))
          option1.yAxis[0].data = this.bar1Data.yAxisData // 设置y轴数据
          option1.series[0].data = this.bar1Data.seriesData // 设置y轴数据

          if (this.type == '3d') { // 3d图形
            let topArr = []
            topArr = this.bar1Data.seriesData.map(item => { // 设置顶部圆柱数据
              if (item.label < 0) {
                return {
                  value: item.value,
                  symbolOffset: [0, 0],
                }
              } else {
                return {
                  value: item.value,
                }
              }
            })
            let bottomArr = []
            bottomArr = this.bar1Data.seriesData.map(item => { // 设置底部圆柱数据
              if (item.value < 0) {
                return {
                  value: item.value,
                  symbolOffset: [0, 0],
                }
              } else {
                return {
                  value: item.value,
                }
              }
            })
            option1.series[0].data = topArr // 设置顶部圆柱数据
            option1.series[1].data = this.bar1Data.seriesData // 设置x轴数据
            option1.series[2].data = bottomArr // 设置底部圆柱数据
            option1.series[1].backgroundStyle = { // 设置柱状图背景色
              color: '#fff',
              borderRadius: 0,
            }
            option1.series[1].itemStyle.color = params => { // 设置柱状图颜色
              if (params.data.value < 0) { // 根据数值的正负设置颜色渐变
                return new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                  {
                    offset: 1, // 0%处的颜色
                    color: '#d32f2e',
                  },
                  {
                    offset: 0, // 100%处的颜色
                    color: '#FEAB66',
                  },
                ])
              } else {
                return new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                  {
                    offset: 0, // 0%处的颜色
                    color: '#d32f2e',
                  },
                  {
                    offset: 1, // 100%处的颜色
                    color: '#FEAB66',
                  },
                ])
              }
            }
          } else if (this.type == 'bar') { // 柱状图
            option1.series[0].data = [] // 清除顶部圆柱数据
            option1.series[1].data = this.bar1Data.seriesData // 设置x轴数据
            option1.series[1].itemStyle.borderRadius = 8 // 设置柱状图圆角
            option1.series[2].data = [] // 清除底部圆柱数据
          } else if (this.type == 'area') { // 折线图
            option1.series[0].data = [] // 清空顶部圆柱数据
            option1.series[1].data = this.bar1Data.seriesData // 设置x轴数据
            option1.series[1].type = 'line' // 设置折线图类型
            option1.series[1].smooth = true // 设置折线图平滑
            option1.series[1].symbol = 'circle' // 设置折线图圆点样式
            option1.series[1].symbolSize = 6 // 设置折线图圆点大小
            option1.series[1].areaStyle = { // 设置折线图区域颜色
              color: new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                {
                  offset: 1,
                  color: 'rgba(254,171,102,0)',
                },
                {
                  offset: 0,
                  color: 'rgba(235,92,91,0.7)',
                },
              ]),
            }
            option1.series[2].data = [] // 清除底部圆柱数据
          }
          if (this.theme == 'purple') { // 紫色
            option1.series[0].itemStyle.color = '#FFF1D0'
            option1.series[1].itemStyle.color = '#F9CD70'
            if (option1.series[1].areaStyle) { // 如果折线图存在设置折线图区域颜色
              option1.series[1].areaStyle = {
                color: new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                  {
                    offset: 1,
                    color: 'rgba(249, 205, 112, 0)',
                  },
                  {
                    offset: 0,
                    color: 'rgba(249, 205, 112, 0.70)',
                  },
                ]),
              }
            }
            option1.series[1].label.color = '#2A234C' // 设置字体颜色
            option1.series[1].label.fontSize = 12 // 设置字体大小
            option1.series[1].label.fontWeight = 400 // 设置字体粗细
            option1.series[2].itemStyle.color = '#EBB94F' // 设置颜色
          } else if (this.theme == 'blue') { // 蓝色
            option1.color = ['#4782EA']
            if(this.type == '3d'){ // 3d图形
              option1.series[1].backgroundStyle = { // 设置柱状图背景色
                color: '#ECF2FD',
                borderRadius: 0,
              }
            }
            option1.series[0].itemStyle.color = '#92D5FF' // 设置颜色
            option1.series[1].itemStyle.color = params => { // 设置颜色
              if (params.data.value < 0) { // 根据数值的正负设置颜色渐变
                return new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                  {
                    offset: 1, // 0%处的颜色
                    color: '#59B9F5',
                  },
                  {
                    offset: 0, // 100%处的颜色
                    color: '#D7F0FF',
                  },
                ])
              } else {
                return new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                  {
                    offset: 1, // 0%处的颜色
                    color: '#D7F0FF',
                  },
                  {
                    offset: 0, // 100%处的颜色
                    color: '#59B9F5',
                  },
                ])
              }
            }
            if (option1.series[1].areaStyle) { // 如果折线图存在设置折线图区域颜色
              option1.series[1].areaStyle = {
                color: new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                  {
                    offset: 1,
                    color: 'rgba(91, 186, 245, 0)',
                  },
                  {
                    offset: 0,
                    color: 'rgba(103, 191, 245, 1)',
                  },
                ]),
              }
            }
            option1.series[1].label.color = '#000000' // 设置字体颜色
            option1.series[1].label.fontSize = 12 // 设置字体大小
            option1.series[1].label.fontWeight = 400 // 设置字体粗细
            option1.series[2].itemStyle.color = '#C0E6FF' // 设置颜色
          } else if (this.theme == 'yellow') { // 黄色
            option1.color = ['#F8BC27']
            option1.series[0].itemStyle.color = '#FFBE1E' // 设置颜色
            option1.series[1].itemStyle.color = params => {
              if (params.data.value < 0) { // 根据数值的正负设置颜色渐变
                return new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                  {
                    offset: 1, // 0%处的颜色
                    color: 'rgba(248,188,39,0)',
                  },
                  {
                    offset: 0, // 100%处的颜色
                    color: 'rgba(248,188,39,0.7)',
                  },
                ])
              } else {
                return new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                  {
                    offset: 1,
                    color: 'rgba(248,188,39,0)',
                  },
                  {
                    offset: 0,
                    color: 'rgba(248,188,39,0.7)',
                  },
                ])
              }
            }
            if (option1.series[1].areaStyle) { // 如果折线图存在设置折线图区域颜色
              option1.series[1].areaStyle = {
                color: new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                  {
                    offset: 1,
                    color: 'rgba(248,188,39,0)',
                  },
                  {
                    offset: 0,
                    color: 'rgba(248,188,39,0.7)',
                  },
                ]),
              }
            }
            option1.series[1].label.color = '#000000' // 设置字体颜色
            option1.series[1].label.fontSize = 12 // 设置字体大小
            option1.series[1].label.fontWeight = 400 // 设置字体粗细
            option1.series[2].itemStyle.color = '#DFA20A' // 设置颜色
          }

          if (this.theme == 'red') { // 红色
            if (this.type != "area") { // 柱状图、3d图形设置颜色渐变
              option1.series[1].itemStyle.color = params => {
                if (params.data.value < 0) { // 根据数值的正负设置颜色渐变
                  return new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                    {
                      offset: 0, // 0%处的颜色
                      color: '#d32f2e',
                    },
                    {
                      offset: 1, // 100%处的颜色
                      color: '#FEAB66',
                    },
                  ])
                } else {
                  return new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                    {
                      offset: 0, // 0%处的颜色
                      color: '#d32f2e',
                    },
                    {
                      offset: 1, // 100%处的颜色
                      color: '#FEAB66',
                    },
                  ])
                }
              }
            }
          } else if (this.theme == 'purple') { // 紫色
            option1.series[1].itemStyle.color = '#F9CD70' // 设置颜色
            if(this.type != '3d'){ // 柱状图、折线图设置背景色
              option1.series[1].backgroundStyle.color = 'rgba(249,205,112,0.2)'
            }
            option1.series[1].label.color = '#2A234C' // 设置字体颜色
            option1.series[1].label.fontSize = 14 // 设置字体大小
            option1.series[1].label.fontWeight = 400 // 设置字体粗细
          } else if (this.theme == 'blue') { // 蓝色
            option1.series[1].itemStyle.color = params => {
              if (params.data.value < 0) { // 根据数值的正负设置颜色渐变
                return new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                  {
                    offset: 1, // 0%处的颜色
                    color: '#D7F0FF',
                  },
                  {
                    offset: 0, // 100%处的颜色
                    color: '#59B9F5',
                  },
                ])
              } else {
                return new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                  {
                    offset: 1, // 0%处的颜色
                    color: '#D7F0FF',
                  },
                  {
                    offset: 0, // 100%处的颜色
                    color: '#59B9F5',
                  },
                ])
              }
            }
            if(this.type != '3d'){ // 柱状图、折线图设置背景色
              option1.series[1].backgroundStyle.color = '#E5E5E5'
            }
            option1.series[1].label.color = '#0A0A0A' // 设置字体颜色
            option1.series[1].label.fontSize = 14 // 设置字体大小
            option1.series[1].label.fontWeight = 400 // 设置字体粗细
          } else if (this.theme == 'yellow') { // 黄色
            option1.xAxis[0].axisLabel.color = '#0A0A0A' // 设置字体颜色
            if(this.type == 'bar'){ // 柱状图设置颜色
              option1.series[1].itemStyle.color = '#F8BC27'
            }
            if(this.type != '3d'){ // 折线图、柱状图设置背景色
              option1.series[1].backgroundStyle.color = '#EAEAEA'
            }
            option1.series[1].label.color = '#0A0A0A' // 设置字体颜色
            option1.series[1].label.fontSize = 14 // 设置字体大小
            option1.series[1].label.fontWeight = 400 // 设置字体粗细
          }

          const arr = this.bar1Data.seriesData.filter(item => item.value < 0) // 获取负数的数组
          if (arr.length > 0) { // 负数有值时，设置x轴最小值，显示负数
            option1.xAxis[0].min = -100
            option1.yAxis[0].axisLine.show = true
          }

          option1.series[1].label.formatter = function (params) { // 设置标签格式
            // 使用自定义的 labelValue 来显示标签
            return params.data.label + '%'
          }
          myChart1.setOption(option1) // 设置option
        }
        if (this.$refs.chart2) {
          const myChart2 = echarts.init(this.$refs.chart2)
          const option2 = JSON.parse(JSON.stringify(this.barOption))
          option2.yAxis[0].data = this.bar2Data.yAxisData
          option2.series[0].data = this.bar2Data.seriesData
          if (this.type == '3d') {
            let topArr = []
            topArr = this.bar2Data.seriesData.map(item => {
              if (item.value < 0) {
                return {
                  value: item.value,
                  symbolOffset: [0, 0],
                }
              } else {
                return {
                  value: item.value,
                }
              }
            })
            let bottomArr = []
            bottomArr = this.bar2Data.seriesData.map(item => {
              if (item.value < 0) {
                return {
                  value: item.value,
                  symbolOffset: [0, 0],
                }
              } else {
                return {
                  value: item.value,
                }
              }
            })
            option2.series[0].data = topArr
            option2.series[1].data = this.bar2Data.seriesData
            option2.series[2].data = bottomArr
            option2.series[1].backgroundStyle = {
              color: '#fff',
              borderRadius: 0,
            }
            option2.series[1].itemStyle.color = params => {
              if (params.data.value < 0) {
                return new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                  {
                    offset: 1, // 0%处的颜色
                    color: '#d32f2e',
                  },
                  {
                    offset: 0, // 100%处的颜色
                    color: '#FEAB66',
                  },
                ])
              } else {
                return new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                  {
                    offset: 0, // 0%处的颜色
                    color: '#d32f2e',
                  },
                  {
                    offset: 1, // 100%处的颜色
                    color: '#FEAB66',
                  },
                ])
              }
            }
          } else if (this.type == 'bar') {
            option2.series[0].data = []
            option2.series[1].data = this.bar2Data.seriesData
            option2.series[1].itemStyle.borderRadius = 8
            option2.series[2].data = []
          } else if (this.type == 'area') {
            option2.series[0].data = []
            option2.series[1].data = this.bar2Data.seriesData
            option2.series[1].type = 'line'
            option2.series[1].smooth = true
            option2.series[1].symbol = 'circle'
            option2.series[1].symbolSize = 6
            option2.series[1].areaStyle = {
              color: new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                {
                  offset: 1,
                  color: 'rgba(254,171,102,0)',
                },
                {
                  offset: 0,
                  color: 'rgba(235,92,91,0.7)',
                },
              ]),
            }
            option2.series[2].data = []
          }
          if (this.theme == 'purple') {
            option2.series[0].itemStyle.color = '#D9EFFF'
            option2.series[1].itemStyle.color = '#8BCAEA'
            if (option2.series[1].areaStyle) {
              option2.series[1].areaStyle = {
                color: new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                  {
                    offset: 1,
                    color: 'rgba(159, 161, 225, 0)',
                  },
                  {
                    offset: 0,
                    color: 'rgba(159, 161, 225, 1)',
                  },
                ]),
              }
            }
            option2.series[1].label.color = '#2A234C'
            option2.series[1].label.fontSize = 12
            option2.series[1].label.fontWeight = 400
            option2.series[2].itemStyle.color = '#72BDE4'
          } else if (this.theme == 'blue') {
            option2.color = ['#4782EA']
            if(this.type == '3d'){
              option2.series[1].backgroundStyle = {
                color: '#ECF2FD',
                borderRadius: 0,
              }
            }
            option2.series[0].itemStyle.color = '#92D5FF'
            option2.series[1].itemStyle.color = params => {
              if (params.data.value < 0) {
                return new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                  {
                    offset: 1, // 0%处的颜色
                    color: '#D7F0FF',
                  },
                  {
                    offset: 0, // 100%处的颜色
                    color: '#59B9F5',
                  },
                ])
              } else {
                return new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                  {
                    offset: 1, // 0%处的颜色
                    color: '#D7F0FF',
                  },
                  {
                    offset: 0, // 100%处的颜色
                    color: '#59B9F5',
                  },
                ])
              }
            }
            if (option2.series[1].areaStyle) {
              option2.series[1].areaStyle = {
                color: new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                  {
                    offset: 1,
                    color: 'rgba(91, 186, 245, 0)',
                  },
                  {
                    offset: 0,
                    color: 'rgba(103, 191, 245, 1)',
                  },
                ]),
              }
            }
            option2.series[1].label.color = '#000000'
            option2.series[1].label.fontSize = 12
            option2.series[1].label.fontWeight = 400
            option2.series[2].itemStyle.color = '#C0E6FF'
          } else if (this.theme == 'yellow') {
            option2.color = ['#F8BC27']
            option2.series[0].itemStyle.color = '#FFBE1E'
            option2.series[1].itemStyle.color = params => {
              if (params.data.value < 0) {
                return new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                  {
                    offset: 1, // 0%处的颜色
                    color: 'rgba(248,188,39,0)',
                  },
                  {
                    offset: 0, // 100%处的颜色
                    color: 'rgba(248,188,39,0.7)',
                  },
                ])
              } else {
                return new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                  {
                    offset: 1,
                    color: 'rgba(248,188,39,0)',
                  },
                  {
                    offset: 0,
                    color: 'rgba(248,188,39,0.7)',
                  },
                ])
              }
            }
            if (option2.series[1].areaStyle) {
              option2.series[1].areaStyle = {
                color: new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                  {
                    offset: 1,
                    color: 'rgba(248,188,39,0)',
                  },
                  {
                    offset: 0,
                    color: 'rgba(248,188,39,0.7)',
                  },
                ]),
              }
            }
            option2.series[1].label.color = '#000000'
            option2.series[1].label.fontSize = 12
            option2.series[1].label.fontWeight = 400
            option2.series[2].itemStyle.color = '#DFA20A'
          }
          if (this.theme == 'red') {
            if (this.type != "area") {
              option2.series[1].itemStyle.color = params => {
                if (params.data.value < 0) {
                  return new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                    {
                      offset: 0, // 0%处的颜色
                      color: '#d32f2e',
                    },
                    {
                      offset: 1, // 100%处的颜色
                      color: '#FEAB66',
                    },
                  ])
                } else {
                  return new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                    {
                      offset: 0, // 0%处的颜色
                      color: '#d32f2e',
                    },
                    {
                      offset: 1, // 100%处的颜色
                      color: '#FEAB66',
                    },
                  ])
                }
              }
            }
          } else if (this.theme == 'purple') {
            option2.series[0].itemStyle.color = '#E3D8FA'
            option2.series[2].itemStyle.color = '#9B7EC1'
            option2.series[1].itemStyle.color = '#9FA1E1'
            if(this.type != '3d'){
              option2.series[1].backgroundStyle.color = 'rgba(159,161,225,0.2)'
            }
            option2.series[1].label.color = '#2A234C'
            option2.series[1].label.fontSize = 14
            option2.series[1].label.fontWeight = 400
          } else if (this.theme == 'blue') {
            option2.series[1].itemStyle.color = params => {
              if (params.data.value < 0) {
                return new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                  {
                    offset: 1, // 0%处的颜色
                    color: '#D7F0FF',
                  },
                  {
                    offset: 0, // 100%处的颜色
                    color: '#59B9F5',
                  },
                ])
              } else {
                return new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                  {
                    offset: 1, // 0%处的颜色
                    color: '#D7F0FF',
                  },
                  {
                    offset: 0, // 100%处的颜色
                    color: '#59B9F5',
                  },
                ])
              }
            }
            if(this.type != '3d'){
              option2.series[1].backgroundStyle.color = '#E5E5E5'
            }
            option2.series[1].label.color = '#0A0A0A'
            option2.series[1].label.fontSize = 14
            option2.series[1].label.fontWeight = 400
          } else if (this.theme == 'yellow') {
            option2.xAxis[0].axisLabel.color = '#0A0A0A'
            if(this.type == 'bar'){
              option2.series[1].itemStyle.color = '#F8BC27'
            }
            if(this.type != '3d'){
              option2.series[1].backgroundStyle.color = '#EAEAEA'
            }
            option2.series[1].label.color = '#0A0A0A'
            option2.series[1].label.fontSize = 14
            option2.series[1].label.fontWeight = 400
          }
          option2.series[1].label.formatter = function (params) {
            // 使用自定义的 labelValue 来显示标签
            return params.data.label + '%'
          }
          const arr = this.bar2Data.seriesData.filter(item => item.value < 0)
          if (arr.length > 0) {
            option2.xAxis[0].min = -100
            option2.yAxis[0].axisLine.show = true
          }
          myChart2.setOption(option2)
        }
        if (this.$refs.chart3) {
          const myChart3 = echarts.init(this.$refs.chart3)
          const option3 = JSON.parse(JSON.stringify(this.barOption))
          option3.yAxis[0].data = this.bar3Data.yAxisData
          option3.series[0].data = this.bar3Data.seriesData

          if (this.type == '3d') {
            let topArr = []
            topArr = this.bar3Data.seriesData.map(item => {
              if (item.value < 0) {
                return {
                  value: item.value,
                  symbolOffset: [0, 0],
                }
              } else {
                return {
                  value: item.value,
                }
              }
            })
            let bottomArr = []
            bottomArr = this.bar3Data.seriesData.map(item => {
              if (item.value < 0) {
                return {
                  value: item.value,
                  symbolOffset: [0, 0],
                }
              } else {
                return {
                  value: item.value,
                }
              }
            })
            option3.series[0].data = topArr
            option3.series[1].data = this.bar3Data.seriesData
            option3.series[2].data = bottomArr
            option3.series[1].backgroundStyle = {
              color: '#fff',
              borderRadius: 0,
            }
            option3.series[1].itemStyle.color = params => {
              if (params.data.value < 0) {
                return new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                  {
                    offset: 1, // 0%处的颜色
                    color: '#d32f2e',
                  },
                  {
                    offset: 0, // 100%处的颜色
                    color: '#FEAB66',
                  },
                ])
              } else {
                return new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                  {
                    offset: 0, // 0%处的颜色
                    color: '#d32f2e',
                  },
                  {
                    offset: 1, // 100%处的颜色
                    color: '#FEAB66',
                  },
                ])
              }
            }
          } else if (this.type == 'bar') {
            option3.series[0].data = []
            option3.series[1].data = this.bar3Data.seriesData
            option3.series[1].itemStyle.borderRadius = 8
            option3.series[2].data = []
          } else if (this.type == 'area') {
            option3.series[0].data = []
            option3.series[1].data = this.bar3Data.seriesData
            option3.series[1].type = 'line'
            option3.series[1].smooth = true
            option3.series[1].symbol = 'circle'
            option3.series[1].symbolSize = 6
            option3.series[1].areaStyle = {
              color: new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                {
                  offset: 1,
                  color: 'rgba(254,171,102,0)',
                },
                {
                  offset: 0,
                  color: 'rgba(235,92,91,0.7)',
                },
              ]),
            }
            option3.series[2].data = []
          }
          if (this.theme == 'red') {
            if (this.type != "area") {
              option3.series[1].itemStyle.color = params => {
                if (params.data.value < 0) {
                  return new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                    {
                      offset: 0, // 0%处的颜色
                      color: '#d32f2e',
                    },
                    {
                      offset: 1, // 100%处的颜色
                      color: '#FEAB66',
                    },
                  ])
                } else {
                  return new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                    {
                      offset: 0, // 0%处的颜色
                      color: '#d32f2e',
                    },
                    {
                      offset: 1, // 100%处的颜色
                      color: '#FEAB66',
                    },
                  ])
                }
              }
            }
          } else if (this.theme == 'purple') {
            option3.series[0].itemStyle.color = '#D9EFFF'
            option3.series[1].itemStyle.color = '#8BCAEA'
            if (option3.series[1].areaStyle) {
              option3.series[1].areaStyle = {
                color: new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                  {
                    offset: 1,
                    color: 'rgba(139, 202, 234, 0)',
                  },
                  {
                    offset: 0,
                    color: 'rgba(139, 202, 234, 0.70)',
                  },
                ]),
              }
            }
            option3.series[1].label.color = '#2A234C'
            option3.series[1].label.fontSize = 12
            option3.series[1].label.fontWeight = 400
            option3.series[2].itemStyle.color = '#72BDE4'
          } else if (this.theme == 'blue') {
            option3.color = ['#4782EA']
            if(this.type == '3d'){
              option3.series[1].backgroundStyle = {
                color: '#ECF2FD',
                borderRadius: 0,
              }
            }
            option3.series[0].itemStyle.color = '#92D5FF'
            option3.series[1].itemStyle.color = params => {
              if (params.data.value < 0) {
                return new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                  {
                    offset: 1, // 0%处的颜色
                    color: '#D7F0FF',
                  },
                  {
                    offset: 0, // 100%处的颜色
                    color: '#59B9F5',
                  },
                ])
              } else {
                return new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                  {
                    offset: 1, // 0%处的颜色
                    color: '#D7F0FF',
                  },
                  {
                    offset: 0, // 100%处的颜色
                    color: '#59B9F5',
                  },
                ])
              }
            }
            if (option3.series[1].areaStyle) {
              option3.series[1].areaStyle = {
                color: new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                  {
                    offset: 1,
                    color: 'rgba(91, 186, 245, 0)',
                  },
                  {
                    offset: 0,
                    color: 'rgba(103, 191, 245, 1)',
                  },
                ]),
              }
            }
            option3.series[1].label.color = '#000000'
            option3.series[1].label.fontSize = 12
            option3.series[1].label.fontWeight = 400
            option3.series[2].itemStyle.color = '#C0E6FF'
          } else if (this.theme == 'yellow') {
            option3.color = ['#F8BC27']
            option3.series[0].itemStyle.color = '#FFBE1E'
            option3.series[1].itemStyle.color = params => {
              if (params.data.value < 0) {
                return new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                  {
                    offset: 1, // 0%处的颜色
                    color: 'rgba(248,188,39,0)',
                  },
                  {
                    offset: 0, // 100%处的颜色
                    color: 'rgba(248,188,39,0.7)',
                  },
                ])
              } else {
                return new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                  {
                    offset: 1,
                    color: 'rgba(248,188,39,0)',
                  },
                  {
                    offset: 0,
                    color: 'rgba(248,188,39,0.7)',
                  },
                ])
              }
            }
            if (option3.series[1].areaStyle) {
              option3.series[1].areaStyle = {
                color: new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                  {
                    offset: 1,
                    color: 'rgba(248,188,39,0)',
                  },
                  {
                    offset: 0,
                    color: 'rgba(248,188,39,0.7)',
                  },
                ]),
              }
            }
            option3.series[1].label.color = '#000000'
            option3.series[1].label.fontSize = 12
            option3.series[1].label.fontWeight = 400
            option3.series[2].itemStyle.color = '#DFA20A'
          }
          if (this.theme == 'purple') {
            option3.series[1].itemStyle.color = '#8BCAEA'
            if(this.type != '3d'){
              option3.series[1].backgroundStyle.color = 'rgba(139,202,234,0.2)'
            }
            option3.series[1].label.color = '#2A234C'
            option3.series[1].label.fontSize = 14
            option3.series[1].label.fontWeight = 400
          } else if (this.theme == 'blue') {
            option3.series[1].itemStyle.color = params => {
              if (params.data.value < 0) {
                return new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                  {
                    offset: 1, // 0%处的颜色
                    color: '#D7F0FF',
                  },
                  {
                    offset: 0, // 100%处的颜色
                    color: '#59B9F5',
                  },
                ])
              } else {
                return new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                  {
                    offset: 1, // 0%处的颜色
                    color: '#D7F0FF',
                  },
                  {
                    offset: 0, // 100%处的颜色
                    color: '#59B9F5',
                  },
                ])
              }
            }
            if(this.type != '3d'){
              option3.series[1].backgroundStyle.color = '#E5E5E5'
            }
            option3.series[1].label.color = '#0A0A0A'
            option3.series[1].label.fontSize = 14
            option3.series[1].label.fontWeight = 400
          } else if (this.theme == 'yellow') {
            option3.xAxis[0].axisLabel.color = '#0A0A0A'
            if(this.type == 'bar'){
              option3.series[1].itemStyle.color = '#F8BC27'
            }
            if(this.type != '3d'){
              option3.series[1].backgroundStyle.color = '#EAEAEA'
            }
            option3.series[1].label.color = '#0A0A0A'
            option3.series[1].label.fontSize = 14
            option3.series[1].label.fontWeight = 400
          }
          option3.series[1].label.formatter = function (params) {
            // 使用自定义的 labelValue 来显示标签
            return params.data.label + '%'
          }

          const arr = this.bar3Data.seriesData.filter(item => item.value < 0)
          if (arr.length > 0) {
            option3.xAxis[0].min = -100
            option3.yAxis[0].axisLine.show = true
          }

          myChart3.setOption(option3)
        }
        if (this.$refs.chart4) {
          const myChart4 = echarts.init(this.$refs.chart4)
          const option4 = JSON.parse(JSON.stringify(this.barOption))
          option4.yAxis[0].data = this.bar4Data.yAxisData
          option4.series[0].data = this.bar4Data.seriesData

          console.log(this.type)
          if (this.type == '3d') {
            let topArr = []
            topArr = this.bar4Data.seriesData.map(item => {
              if (item.value < 0) {
                return {
                  value: item.value,
                  symbolOffset: [0, 0],
                }
              } else {
                return {
                  value: item.value,
                }
              }
            })
            let bottomArr = []
            bottomArr = this.bar4Data.seriesData.map(item => {
              if (item.value < 0) {
                return {
                  value: item.value,
                  symbolOffset: [0, 0],
                }
              } else {
                return {
                  value: item.value,
                }
              }
            })
            option4.series[0].data = topArr
            option4.series[1].data = this.bar4Data.seriesData
            option4.series[2].data = bottomArr
            option4.series[1].backgroundStyle = {
              color: '#fff',
              borderRadius: 0,
            }
            option4.series[1].itemStyle.color = params => {
              if (params.data.value < 0) {
                return new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                  {
                    offset: 1, // 0%处的颜色
                    color: '#d32f2e',
                  },
                  {
                    offset: 0, // 100%处的颜色
                    color: '#FEAB66',
                  },
                ])
              } else {
                return new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                  {
                    offset: 0, // 0%处的颜色
                    color: '#d32f2e',
                  },
                  {
                    offset: 1, // 100%处的颜色
                    color: '#FEAB66',
                  },
                ])
              }
            }
          } else if (this.type == 'bar') {
            option4.series[0].data = []
            option4.series[1].data = this.bar4Data.seriesData
            option4.series[1].itemStyle.borderRadius = 8
            option4.series[2].data = []
          } else if (this.type == 'area') {
            option4.series[0].data = []
            option4.series[1].data = this.bar4Data.seriesData
            option4.series[1].type = 'line'
            option4.series[1].smooth = true
            option4.series[1].symbol = 'circle'
            option4.series[1].symbolSize = 6
            option4.series[1].areaStyle = {
              color: new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                {
                  offset: 1,
                  color: 'rgba(254,171,102,0)',
                },
                {
                  offset: 0,
                  color: 'rgba(235,92,91,0.7)',
                },
              ]),
            }
            option4.series[2].data = []
          }
          if (this.theme == 'red') {
            if (this.type != "area") {
              option4.series[1].itemStyle.color = params => {
                if (params.data.value < 0) {
                  return new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                    {
                      offset: 0, // 0%处的颜色
                      color: '#d32f2e',
                    },
                    {
                      offset: 1, // 100%处的颜色
                      color: '#FEAB66',
                    },
                  ])
                } else {
                  return new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                    {
                      offset: 0, // 0%处的颜色
                      color: '#d32f2e',
                    },
                    {
                      offset: 1, // 100%处的颜色
                      color: '#FEAB66',
                    },
                  ])
                }
              }
            }
          } else if (this.theme == 'purple') {
            option4.series[0].itemStyle.color = '#FFE2EA'
            option4.series[1].itemStyle.color = '#F3ADBF'
            if (option4.series[1].areaStyle) {
              option4.series[1].areaStyle = {
                color: new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                  {
                    offset: 1,
                    color: 'rgba(243, 173, 191, 0)',
                  },
                  {
                    offset: 0,
                    color: 'rgba(243, 173, 191, 0.70)',
                  },
                ]),
              }
            }
            option4.series[1].label.color = '#2A234C'
            option4.series[1].label.fontSize = 12
            option4.series[1].label.fontWeight = 400
            option4.series[2].itemStyle.color = '#E887A0'
          } else if (this.theme == 'blue') {
            option4.color = ['#4782EA']
            if(this.type == '3d'){
              option4.series[1].backgroundStyle = {
                color: '#ECF2FD',
                borderRadius: 0,
              }
            }
            option4.series[0].itemStyle.color = '#92D5FF'
            option4.series[1].itemStyle.color = params => {
              if (params.data.value < 0) {
                return new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                  {
                    offset: 1, // 0%处的颜色
                    color: '#D7F0FF',
                  },
                  {
                    offset: 0, // 100%处的颜色
                    color: '#59B9F5',
                  },
                ])
              } else {
                return new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                  {
                    offset: 1, // 0%处的颜色
                    color: '#D7F0FF',
                  },
                  {
                    offset: 0, // 100%处的颜色
                    color: '#59B9F5',
                  },
                ])
              }
            }
            if (option4.series[1].areaStyle) {
              option4.series[1].areaStyle = {
                color: new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                  {
                    offset: 1,
                    color: 'rgba(91, 186, 245, 0)',
                  },
                  {
                    offset: 0,
                    color: 'rgba(103, 191, 245, 1)',
                  },
                ]),
              }
            }
            option4.series[1].label.color = '#000000'
            option4.series[1].label.fontSize = 12
            option4.series[1].label.fontWeight = 400
            option4.series[2].itemStyle.color = '#C0E6FF'
          } else if (this.theme == 'yellow') {
            option4.color = ['#F8BC27']
            option4.series[0].itemStyle.color = '#FFBE1E'
            option4.series[1].itemStyle.color = params => {
              if (params.data.value < 0) {
                return new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                  {
                    offset: 1, // 0%处的颜色
                    color: 'rgba(248,188,39,0)',
                  },
                  {
                    offset: 0, // 100%处的颜色
                    color: 'rgba(248,188,39,0.7)',
                  },
                ])
              } else {
                return new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                  {
                    offset: 1,
                    color: 'rgba(248,188,39,0)',
                  },
                  {
                    offset: 0,
                    color: 'rgba(248,188,39,0.7)',
                  },
                ])
              }
            }
            if (option4.series[1].areaStyle) {
              option4.series[1].areaStyle = {
                color: new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                  {
                    offset: 1,
                    color: 'rgba(248,188,39,0)',
                  },
                  {
                    offset: 0,
                    color: 'rgba(248,188,39,0.7)',
                  },
                ]),
              }
            }
            option4.series[1].label.color = '#000000'
            option4.series[1].label.fontSize = 12
            option4.series[1].label.fontWeight = 400
            option4.series[2].itemStyle.color = '#DFA20A'
          }
          if (this.theme == 'purple') {
            option4.series[1].itemStyle.color = '#F3ADBF'
            if(this.type != '3d'){
              option4.series[1].backgroundStyle.color = 'rgba(243,173,191,0.2)'
            }
            option4.series[1].label.color = '#2A234C'
            option4.series[1].label.fontSize = 14
            option4.series[1].label.fontWeight = 400
            option4.series[0].itemStyle.color = '#FFE2EA'
            option4.series[2].itemStyle.color = '#E887A0'
          } else if (this.theme == 'blue') {
            option4.series[1].itemStyle.color = params => {
              if (params.data.value < 0) {
                return new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                  {
                    offset: 1, // 0%处的颜色
                    color: '#D7F0FF',
                  },
                  {
                    offset: 0, // 100%处的颜色
                    color: '#59B9F5',
                  },
                ])
              } else {
                return new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                  {
                    offset: 1, // 0%处的颜色
                    color: '#D7F0FF',
                  },
                  {
                    offset: 0, // 100%处的颜色
                    color: '#59B9F5',
                  },
                ])
              }
            }
            if(this.type != '3d'){
              option4.series[1].backgroundStyle.color = '#E5E5E5'
            }
            option4.series[1].label.color = '#0A0A0A'
            option4.series[1].label.fontSize = 14
            option4.series[1].label.fontWeight = 400
          } else if (this.theme == 'yellow') {
            option4.xAxis[0].axisLabel.color = '#0A0A0A'
            if(this.type == 'bar'){
              option4.series[1].itemStyle.color = '#F8BC27'
            }
            if(this.type != '3d'){
              option4.series[1].backgroundStyle.color = '#EAEAEA'
            }
            option4.series[1].label.color = '#0A0A0A'
            option4.series[1].label.fontSize = 14
            option4.series[1].label.fontWeight = 400
          }
          option4.series[1].label.formatter = function (params) {
            // 使用自定义的 labelValue 来显示标签
            return params.data.label + '%'
          }

          const arr = this.bar4Data.seriesData.filter(item => item.value < 0)
          if (arr.length > 0) {
            option4.xAxis[0].min = -100
            option4.yAxis[0].axisLine.show = true
          }
          myChart4.setOption(option4)
        }
      },
    },
  }
  </script>

  <style lang="scss" scoped>
  .red {
    .profitability {
      margin-top: 14px;
      width: 1040px;
      height: 503px;
      position: relative;
      background: #ffffff;
      box-shadow: 2px 2px 10px 6px rgba(211, 47, 46, 0.07);
      border: 1px solid rgba(211, 47, 46, 0.07);
    }
  }

  .purple {
    .profitability {
      margin-top: 14px;
      width: 1040px;
      height: 503px;
      position: relative;
      background: #ffffff;
      box-shadow: 2px 2px 10px 6px rgba(211, 47, 46, 0.07);
      border: 1px solid rgba(211, 47, 46, 0.07);
    }
  }

  .cards {
    margin-top: 14px;
    padding: 0 50px;
    display: flex;
    justify-content: space-between;
  }
  .cards1 {
    margin-top: 14px;
    padding: 0 50px;
    display: flex;
    justify-content: space-around;
  }

  .zh_income {
    height: 33px;
    font-size: 24px;
    font-weight: 600;
    color: var(--contentTitleColor);
    line-height: 33px;
  }
  .en_income {
    height: 40px;
    font-size: 28px;
    font-weight: 600;
    color: var(--contentTitleColor);
    line-height: 40px;
  }
  .money {
    height: 59px;
    font-size: 42px;
    font-weight: 600;
    color: var(--numColor);
    line-height: 59px;
  }
  .unit {
    font-size: 16px;
  }

  .card {
    width: 492px;
    height: 352px;
    border-radius: 8px;
    border: 1px solid var(--borderColor);
    text-align: center;
    align-items: center;
  }

  .card2 {
    width: 454px;
    height: 333px;
    border-radius: 8px;
    border: 1px solid var(--borderColor);
    text-align: center;
  }

  .card3 {
    width: 292px;
    height: 333px;
    border-radius: 8px;
    border: 1px solid var(--borderColor);
    text-align: center;
  }

  .cards4 {
    margin-top: 12px;
    padding: 0 50px;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
  }
  .mt {
    margin-top: 16px;
  }
  .card4 {
    width: 410px;
    height: 168px;
    border-radius: 8px;
    border: 1px solid var(--borderColor);
    display: flex;
    justify-content: space-between;
    padding-left: 18px;
    padding-right: 10px;
  }
  .column {
    display: flex;
    justify-content: space-between;
  }

  .line {
    margin: 22px 8px 0 8px;
    width: 1px;
    height: 132px;
    background-color: #f9eded;
  }

  .zh .card-title {
    margin-top: 36px;
    height: 30px;
    font-size: 18px;
    font-weight: 600;
    color: var(--timeTitleColor);
    line-height: 25px;
  }
  .zh .card-text {
    height: 30px;
    font-weight: 600;
    line-height: 25px;
    color: var(--contentTitleColor);
    font-size: 22px;
  }
  .zh .num {
    height: 50px;
    font-size: 36px;
    font-weight: 600;
    color: var(--numColor);
    line-height: 50px;
  }
  .unit {
    font-size: 16px;
  }
  .en .card-title {
    margin-top: 16px;
    height: 30px;
    font-size: 18px;
    font-weight: 600;
    color: var(--timeTitleColor);
    line-height: 25px;
  }
  .en .card-text {
    height: 30px;
    font-weight: 600;
    line-height: 25px;
    font-size: 18px;
    color: var(--contentTitleColor);
  }
  .en .num {
    height: 50px;
    font-size: 36px;
    font-weight: 600;
    color: var(--numColor);
    line-height: 50px;
  }
  .en .num1 {
    height: 50px;
    font-size: 24px;
    font-weight: 600;
    color: var(--numColor);
    line-height: 50px;
  }

  .card4 .en .card-text {
    height: 50px;
    font-weight: 600;
    line-height: 25px;
    font-size: 18px;
    color: var(--baseColor);
  }

  .charts {
    width: 480px;
    height: 200px;
    margin-left: 13px;
  }
  .charts2 {
    width: 450px;
    height: 200px;
    margin-left: 15px;
  }
  .charts3 {
    width: 290px;
    height: 200px;
    margin-left: 5px;
  }
  .charts4 {
    width: 265px;
    height: 165px;
  }
  .blue {
    .profitability {
      padding: 0 80px;
      padding-top: 27px;
      width: 980px;
      height: 489px;
      position: relative;
    }
    .cards {
      margin-top: 34px;
      padding: 0;
      display: flex;
      justify-content: space-between;
    }
    .cards1 {
      margin-top: 34px;
      padding: 0 250px;
      display: flex;
      justify-content: space-between;
    }
    .card {
      width: 500px;
      height: 375px;
      background: #ecf2fd;
      border-radius: 8px;
      border: none;
    }
    .card2 {
      width: 470px;
      height: 375px;
      background: #ecf2fd;
      border-radius: 8px;
      border: none;
    }
    .card3 {
      width: 292px;
      height: 375px;
      background: #ecf2fd;
      border-radius: 8px;
      border: none;
    }
    .cards4 {
      margin-top: 34px;
      padding: 0;
      display: flex;
      justify-content: space-between;
      flex-direction: column;
    }
    .mt {
      margin-top: 39px;
    }
    .card4 {
      display: flex;
      justify-content: space-between;

      width: 470px;
      height: 168px;
      background: #ecf2fd;
      border-radius: 8px;
      border: none;
    }
    .column {
      .card4:nth-child(2) {
        margin-left: 40px;
      }
    }
  }
  .yellow {
    .profitability {
      width: 980px;
      height: 510px;
      padding: 0 80px;
      background: #f5f6f8;
      border-radius: 28px;
      position: relative;
    }

    .line {
      margin: 22px 8px 0 8px;
      width: 1px;
      height: 132px;
      background-color: #eaeaea;
    }

    .cards {
      margin-top: 34px;
      padding: 0;
      display: flex;
      justify-content: space-between;
    }
    .cards1 {
      margin-top: 34px;
      padding: 0 250px;
      display: flex;
      justify-content: space-between;
    }
    .card {
      width: 500px;
      height: 375px;
      background: #ffffff;
      box-shadow: 6px 2px 9px 0px rgba(165, 165, 165, 0.2);
      border-radius: 8px;
      border: none;
    }
    .card2 {
      width: 470px;
      height: 375px;
      background: #ffffff;
      box-shadow: 6px 2px 9px 0px rgba(165, 165, 165, 0.2);
      border-radius: 8px;
      border: none;
    }
    .card3 {
      width: 292px;
      height: 375px;
      background: #ffffff;
      box-shadow: 6px 2px 9px 0px rgba(165, 165, 165, 0.2);
      border-radius: 8px;
      border: none;
    }

    .cards4 {
      margin-top: 29px;
      padding: 0;
      display: flex;
      justify-content: space-between;
      flex-direction: column;
    }
    .mt {
      margin-top: 39px;
    }

    .card4 {
      width: 470px;
      height: 168px;
      background: #ffffff;
      box-shadow: 6px 2px 9px 0px rgba(165, 165, 165, 0.2);
      border-radius: 8px;
      border: none;
    }

    .column {
      .card4:nth-child(2) {
        margin-left: 40px;
      }
    }
  }
  </style>
